export default __webpack_public_path__ + "static/speedy10-a9d2b1954ebee531ed3ef198ca64090a.svg";